import React from "react";
import CustomPageHeader from "../../fragments/CustomPageHeader";

export default function JournalEntry({ children }) {
  return (
    <div>
      <CustomPageHeader icon='random' text='Journal entries' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/index.js